/**
 * Find the general customer used as the default retail-sale customer.
 *
 * @param {Array} customers
 * @returns {Object|null}
 */
export function findGeneralCustomer(customers = []) {
  return (
    customers.find(customer => customer.is_general_customer) ||
    customers.find(customer =>
      String(customer.customer_name || '').toLowerCase() === 'general'
    ) ||
    null
  )
}
